function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router';
import { GiveawayUrl } from 'swag-common/utils/urls/giveaway.url';
import { getGiveawayTypeLabel } from 'swag-common/utils/giveaway/giveaway-type.util';
import { getGiveawayByLinkAction } from '../../../redux/giveaway-landing/giveaway-landing.actions';
import { giveawayLinkItemItemSelector, isGiveawayAndLinkLoadedSelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
export let GiveawayPageStatus = /*#__PURE__*/function (GiveawayPageStatus) {
  GiveawayPageStatus[GiveawayPageStatus["landing"] = 0] = "landing";
  GiveawayPageStatus[GiveawayPageStatus["ended"] = 1] = "ended";
  GiveawayPageStatus[GiveawayPageStatus["completed"] = 2] = "completed";
  GiveawayPageStatus[GiveawayPageStatus["deleted"] = 3] = "deleted";
  GiveawayPageStatus[GiveawayPageStatus["suspended"] = 4] = "suspended";
  return GiveawayPageStatus;
}({});
export function giveawayPageResolver(component, pageStatus) {
  class Hoc extends React.PureComponent {
    componentDidMount() {
      const {
        getGiveawayByLinkAction,
        isLoaded
      } = this.props;
      const {
        params: {
          link,
          giveawayType: giveawayTypeName
        }
      } = this.props;
      const giveawayType = GiveawayUrl.getGiveawayTypeByLinkName(giveawayTypeName);
      if (!isLoaded && link) {
        getGiveawayByLinkAction({
          pageStatus,
          link,
          giveawayType
        });
      }
    }
    render() {
      const _this$props = this.props,
        {
          link
        } = _this$props,
        props = _objectWithoutProperties(_this$props, ["link"]);
      const Component = component;
      const additionalProps = this.getTitles(pageStatus, link);
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, additionalProps));
    }
    getTitles(status, link) {
      const {
        params: {
          giveawayType: giveawayTypeName
        }
      } = this.props;
      const giveawayType = GiveawayUrl.getGiveawayTypeByLinkName(giveawayTypeName);
      const giveawayTypeLabel = getGiveawayTypeLabel(giveawayType).toLowerCase();
      switch (status) {
        case GiveawayPageStatus.completed:
          {
            if (link !== null && link !== void 0 && link.feedback) {
              return {
                title: "Amazing, you're all finished!",
                subtitle: 'There is nothing else to do here so you can go ahead and close this tab!'
              };
            }
            return {
              title: "Amazing, you're all finished!",
              subtitle: 'If not, there is nothing else to do here so you can go ahead and close this tab!'
            };
          }
        case GiveawayPageStatus.deleted:
          {
            return {
              title: 'Your link is no longer active.',
              subtitle: `The company has stopped this ${giveawayTypeLabel}. Please be on the lookout for future ${giveawayTypeLabel}s.`
            };
          }
        case GiveawayPageStatus.ended:
          {
            return {
              title: `Sorry, this ${giveawayTypeLabel} has ended.`,
              subtitle: `Be sure to be on the lookout for future ${giveawayTypeLabel}s.`
            };
          }
        default:
          {
            return {};
          }
      }
    }
  }
  const mapStateToProps = createStructuredSelector({
    isLoaded: isGiveawayAndLinkLoadedSelector,
    link: giveawayLinkItemItemSelector
  });
  const mapDispatchToProps = dispatch => bindActionCreators({
    getGiveawayByLinkAction
  }, dispatch);
  const connectedRouter = withRouter(Hoc);
  return connect(mapStateToProps, mapDispatchToProps)(connectedRouter);
}